import { getTestAttributes, slug } from '@chillibean/component-library';

import { getFieldTitle } from '../../../__util__/field';
import withInputLabel from '../hoc/withInputLabel';

export function TextField(props) {
  const {
    value,
    autoComplete,
    disabled,
    handleChange,
    handleBlur,
    handleClick,
    handleKeyDown,
    fieldRequired,
    fieldIdentifier = 'text',
    fieldName,
    showError,
    errorMessage,
    numberOnly = false,
    passwordOnly = false,
    numberMinimum,
    inputRef,
    fieldID = '',
  } = props;

  const handleOnChange = (event) => handleChange && handleChange(event, 'input');
  const handleOnBlur = (event) => handleBlur && handleBlur(event, 'input');
  const handleOnClick = (event) => handleClick && handleClick(event);
  const handleOnKeyDown = (event) => handleKeyDown && handleKeyDown(event);

  const inputType = () => {
    let inputType = 'text';
    if (numberOnly) {
      inputType = 'number';
    }
    if (passwordOnly) {
      inputType = 'password';
    }
    return inputType;
  };

  return (
    <div className="form__field">
      <input
        type={inputType()}
        autoComplete={autoComplete}
        id={fieldID}
        style={!fieldName ? { paddingTop: '15px' } : null}
        className={`form__control ${showError ? 'form__control--validation-error' : ''}`}
        placeholder=" "
        onClick={(event) => handleOnClick(event)}
        onBlur={(event) => handleOnBlur(event)}
        onChange={(event) => handleOnChange(event)}
        onKeyDown={(event) => handleOnKeyDown(event)}
        disabled={disabled}
        value={value}
        min={numberMinimum}
        ref={inputRef}
        {...getTestAttributes(`${slug(fieldIdentifier)}-form-field`)}
      />
      <label htmlFor={fieldID}>{getFieldTitle(fieldRequired, fieldName)}</label>
      {showError && (
        <div className="form__validation-error" data-test-id={`${slug(fieldIdentifier)}-form-field-error-message`}>
          {errorMessage}
        </div>
      )}{' '}
    </div>
  );
}

export default withInputLabel(TextField);
